<template>
    <div class="mb-3">
        <CommissionDetailsModal :show_commission_details.sync="modals.show_commission_details" :commission_details="selectedRow" />
        <IndividualSummaryModal :show_individual_summary.sync="modals.show_individual_summary" :individual_summary="selectedRow" />

        <b-row align-v="center">
            <b-col cols="12" md="auto">
                <h3>Commission Summary</h3>
            </b-col>
            <b-col cols="12" md="7">
                <b-row align-h="center" class="px-3">
                    <b-col cols="6" md="auto" class="px-1">
                        <b-button block variant="outline-primary" class="mb-2 mr-2 shadow-none">All</b-button>
                    </b-col>
                    <b-col cols="6" md="auto" class="px-1">
                        <b-button block variant="outline-primary" class="mb-2 mr-2 shadow-none">Pending</b-button>
                    </b-col>
                    <b-col cols="6" md="auto" class="px-1">
                        <b-button block variant="outline-primary" class="mb-2 mr-2 shadow-none">Partial</b-button>
                    </b-col>
                    <b-col cols="6" md="auto" class="px-1">
                        <b-button block variant="outline-primary" class="mb-2 mr-2 shadow-none">Completed</b-button>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="auto" class="text-md-right">
                <span class="mx-2">Total Net Pay:</span>
                <span class="text-primary font-weight-500 mb-0">
                    RM42,500.00
                </span>
            </b-col>
        </b-row>

        <div class="table-simple-modal">
            <b-table-simple responsive borderless>
                <b-thead>
                    <b-tr>
                        <b-th>#</b-th>
                        <b-th>Date</b-th>
                        <b-th>Customer<br>Name</b-th>
                        <b-th>Product<br>Details</b-th>
                        <b-th>Channel</b-th>
                        <b-th>Sales (RM)</b-th>
                        <b-th>Revenue<br>Point (85%)</b-th>
                        <b-th>
                            Title<br>
                            <el-tooltip placement="bottom" effect="light">
                                <div slot="content">
                                    <TitleDesctiptionTable />
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" class="text-white cursor-pointer" width="16" height="16" viewBox="0 0 512 512">
                                    <path fill="currentColor" d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-40-176h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
                                </svg>
                            </el-tooltip>
                        </b-th>
                        <b-th>Override<br>Mar.</b-th>
                        <b-th>Total<br>Comm.</b-th>
                        <b-th></b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <template>
                        <b-tr v-for="(item, index) in tableData" :key="index">
                            <b-td>{{ index + 1 }}</b-td>
                            <b-td>{{ item.created_at }}</b-td>
                            <b-td class="text-primary font-weight-500 cursor-pointer" @click="individualSummModal(item)">{{ item.case_recognize.case.prod_customer_name | formatUserName(30) }}</b-td>
                            <b-td class="text-primary font-weight-500 cursor-pointer">
                                {{ item.case_recognize.case.prod_type }}
                            </b-td>
                            <b-td>{{ item.comms_payout_summary.payout_distribution.service_type_code }}</b-td>
                            <b-td>{{ item.comms_payout_summary.cps_develop_nett_price | moneyFormatter }}</b-td>
                            <b-td>{{ item.actual_total_revenue_point | moneyFormatter }}</b-td>
                            <b-td>
                            <el-tooltip placement="right">
                                    <!-- <div slot="content">{{ getDescription(item.payout_level_code) }}</div> -->
                                    <template #default>
                                        <div>{{ item.payout_level_code }}</div>
                                    </template>
                                </el-tooltip>
                            </b-td>
                            <b-td>{{ item.payout_percentage }}</b-td>
                            <b-td>{{ item.actual_payout_revenue_point | moneyFormatter }}</b-td>
                            <b-td>
                                <svg xmlns="http://www.w3.org/2000/svg" class="text-primary cursor-pointer" width="16" height="16" viewBox="0 0 512 512" @click="openDetailsModal(item)">
                                    <path fill="currentColor" d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-40-176h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
                                </svg>
                            </b-td>
                        </b-tr>
                    </template>
                </b-tbody>
            </b-table-simple>
        </div>
    </div>
</template>
<script>
import { Button, Tooltip } from 'element-ui'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import CommissionDetailsModal from '@/views/Commission/Payout/PayoutSummaries/Modals/CommissionDetailsModal'
import IndividualSummaryModal from '@/views/Commission/Payout/PayoutSummaries/Modals/IndividualSummaryModal'
import TitleDesctiptionTable from '@/views/Commission/Payout/PayoutSummaries/Tables/TitleDesctiptionTable'

export default {
    mixins: [clientPaginationMixin],
    components: {
        [Button.name]: Button,
        [Tooltip.name]: Tooltip,
        CommissionDetailsModal,
        IndividualSummaryModal,
        TitleDesctiptionTable
    },
    props: ['tableData'],
    data() {
        return {
            tableData1: 
            [
                {
                    date: '18 Dec 2022',
                    customer_name: 'Jazz Ng',
                    channel_name: 'MyAzzahra',
                    platform: 'Agency',
                    channel_type: 'Company',
                    status: 'Submit to Advisory',
                    channel: 'Advisory',
                    product: 'PCB',
                    product_details: 'Nadayu 801 C-15-12A',
                    capture: 'Client Net',
                    sales_value: 514300,
                    revenue_percent: '0.75%',
                    revenue_point: 3857.25,
                    direct_payout: 3278.66,
                    total_comm: 131.15,
                    elite_pool: 202.51,
                    leadership_pool: 202.51,
                    champion_pool: 173.58,
                    total_pool: 578.59,
                    channel_type: 'Company',
                    title: 'LR1',
                    override_margin: '4%',
                },
                {
                    date: '20 Dec 2022',
                    customer_name: 'Teresa K',
                    channel_name: 'Chin Huey Fen',
                    platform: 'Fintos Financial Hub',
                    channel_type: 'Personal',
                    status: 'Direct Submit',
                    channel: 'Non-Advisory',
                    product: 'AF',
                    product_details: 'Personal Loan - 60K',
                    capture: 'Arrangement Fees',
                    sales_value: 6000,
                    revenue_percent: '50%',
                    revenue_point: 3000,
                    direct_payout: 2550,
                    total_comm: 1530,
                    elite_pool: 157.50,
                    leadership_pool: 157.50,
                    champion_pool: 135,
                    total_pool: 450,
                    channel_type: 'Company',
                    title: 'LT1',
                    override_margin: '6%',
                }
            ],
            modals: {
                show_commission_details: false,
                show_individual_summary: false,
            },
            selectedRow: {}
        }
    },
    methods: {
        openDetailsModal(details) {
            this.modals.show_commission_details = true
            this.selectedRow = details
        },
        individualSummModal(details) {
            this.modals.show_individual_summary = true
            this.selectedRow = details
        },
        getDescription(code) {
            // Create a mapping of codes to descriptions
            const codeDescriptions = {
                LT1: "Lead Commission",
                LT2: "Title Overriding Level 1",
                LT3: "Title Overriding Level 2",
                LR1: "Lead Recruit Level 1",
                LR2: "Lead Recruit Level 2",
                LR3: "Lead Recruit Level 3",
                FSM: "Financial Support Manager",
                FA: "Financial Advisor",
                FAM: "Financial Advisor Manager",
                FSD: "Financial Sales Director",
                ASR1: "Advisor Service Recruit Level 1",
                ASR2: "Advisor Service Recruit Level 2",
                ASR3: "Advisor Service Recruit Level 3",
            }

            // Return the description based on the code
            return codeDescriptions[code] || "Unknown"; // Default to "Unknown" if code is not found
        },
    }
}
</script>